var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { LazyLoader } from '../../../ts/components/LazyLoader';
import { Poster2026 } from './part/2026';
export class Poster extends Component {
    constructor() {
        super('Poster', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            //(new Poster2024()).init();
            (new Poster2026()).init();
            if ($('body').hasClass('home')) {
                $('.poster').on('click', () => {
                    Poster.scrollDown();
                });
                $(window).on('scroll', (event) => {
                    if (Poster.isScrollingDisabled)
                        $.scrollTo(0, 0);
                    Poster.scrollDown();
                });
                if (sessionStorage.getItem('poster-removed') === 'true') {
                    $('body').removeClass('has-poster');
                    Poster.isScrollingDisabled = false;
                    LazyLoader.checkImageVisibility();
                }
                $('#site-logo').on('click', () => {
                    sessionStorage.setItem('poster-removed', 'false');
                });
            }
            this.success();
        });
    }
    static scrollDown() {
        if ($('body').hasClass('has-poster')) {
            $('body').addClass('has-transition-1000').removeClass('has-poster');
            $('.poster').addClass('has-transition-1000');
            sessionStorage.setItem('poster-removed', 'true');
            let intervalCount = 0;
            let intervalID = setInterval(() => {
                LazyLoader.checkImageVisibility();
                intervalCount++;
                if (intervalCount === 30)
                    clearInterval(intervalID);
            }, 40);
            setTimeout(() => {
                this.isScrollingDisabled = false;
            }, 1000);
        }
    }
}
Poster.isScrollingDisabled = true;
